// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1UrKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorHexMaps", ()=>colorHexMaps);
parcelHelpers.export(exports, "colorSections", ()=>colorSections);
parcelHelpers.export(exports, "InfoMessage", ()=>InfoMessage);
parcelHelpers.export(exports, "ColorSearchSkeleton", ()=>ColorSearchSkeleton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _infoCircle = require("@react-spectrum/s2/icons/InfoCircle");
var _infoCircleDefault = parcelHelpers.interopDefault(_infoCircle);
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const colorHexMaps = {
    light: {
        black: [
            0,
            0,
            0
        ],
        white: [
            255,
            255,
            255
        ],
        base: [
            255,
            255,
            255
        ],
        "layer-1": [
            248,
            248,
            248
        ],
        pasteboard: [
            233,
            233,
            233
        ],
        elevated: [
            255,
            255,
            255
        ],
        neutral: [
            41,
            41,
            41
        ],
        disabled: [
            198,
            198,
            198
        ],
        accent: [
            59,
            99,
            251
        ],
        "neutral-subdued": [
            80,
            80,
            80
        ],
        negative: [
            215,
            50,
            32
        ],
        heading: [
            19,
            19,
            19
        ],
        title: [
            19,
            19,
            19
        ],
        body: [
            41,
            41,
            41
        ],
        detail: [
            113,
            113,
            113
        ],
        code: [
            41,
            41,
            41
        ],
        "accent-100": [
            245,
            249,
            255
        ],
        "accent-200": [
            229,
            240,
            254
        ],
        "accent-300": [
            203,
            226,
            254
        ],
        "accent-400": [
            172,
            207,
            253
        ],
        "accent-500": [
            142,
            185,
            252
        ],
        "accent-600": [
            114,
            158,
            253
        ],
        "accent-700": [
            93,
            137,
            255
        ],
        "accent-800": [
            75,
            117,
            255
        ],
        "accent-900": [
            59,
            99,
            251
        ],
        "accent-1000": [
            39,
            77,
            234
        ],
        "accent-1100": [
            29,
            62,
            207
        ],
        "accent-1200": [
            21,
            50,
            173
        ],
        "accent-1300": [
            16,
            40,
            140
        ],
        "accent-1400": [
            12,
            31,
            105
        ],
        "accent-1500": [
            14,
            24,
            67
        ],
        "accent-1600": [
            7,
            11,
            30
        ],
        "informative-100": [
            245,
            249,
            255
        ],
        "informative-200": [
            229,
            240,
            254
        ],
        "informative-300": [
            203,
            226,
            254
        ],
        "informative-400": [
            172,
            207,
            253
        ],
        "informative-500": [
            142,
            185,
            252
        ],
        "informative-600": [
            114,
            158,
            253
        ],
        "informative-700": [
            93,
            137,
            255
        ],
        "informative-800": [
            75,
            117,
            255
        ],
        "informative-900": [
            59,
            99,
            251
        ],
        "informative-1000": [
            39,
            77,
            234
        ],
        "informative-1100": [
            29,
            62,
            207
        ],
        "informative-1200": [
            21,
            50,
            173
        ],
        "informative-1300": [
            16,
            40,
            140
        ],
        "informative-1400": [
            12,
            31,
            105
        ],
        "informative-1500": [
            14,
            24,
            67
        ],
        "informative-1600": [
            7,
            11,
            30
        ],
        "negative-100": [
            255,
            246,
            245
        ],
        "negative-200": [
            255,
            235,
            232
        ],
        "negative-300": [
            255,
            214,
            209
        ],
        "negative-400": [
            255,
            188,
            180
        ],
        "negative-500": [
            255,
            157,
            145
        ],
        "negative-600": [
            255,
            118,
            101
        ],
        "negative-700": [
            255,
            81,
            61
        ],
        "negative-800": [
            240,
            56,
            35
        ],
        "negative-900": [
            215,
            50,
            32
        ],
        "negative-1000": [
            183,
            40,
            24
        ],
        "negative-1100": [
            156,
            33,
            19
        ],
        "negative-1200": [
            129,
            27,
            14
        ],
        "negative-1300": [
            104,
            21,
            10
        ],
        "negative-1400": [
            80,
            16,
            6
        ],
        "negative-1500": [
            59,
            11,
            4
        ],
        "negative-1600": [
            29,
            5,
            2
        ],
        "notice-100": [
            255,
            246,
            231
        ],
        "notice-200": [
            255,
            236,
            207
        ],
        "notice-300": [
            255,
            218,
            158
        ],
        "notice-400": [
            255,
            193,
            94
        ],
        "notice-500": [
            255,
            162,
            19
        ],
        "notice-600": [
            252,
            125,
            0
        ],
        "notice-700": [
            232,
            106,
            0
        ],
        "notice-800": [
            212,
            91,
            0
        ],
        "notice-900": [
            194,
            78,
            0
        ],
        "notice-1000": [
            167,
            62,
            0
        ],
        "notice-1100": [
            144,
            51,
            0
        ],
        "notice-1200": [
            118,
            41,
            0
        ],
        "notice-1300": [
            95,
            32,
            0
        ],
        "notice-1400": [
            73,
            24,
            0
        ],
        "notice-1500": [
            52,
            18,
            0
        ],
        "notice-1600": [
            25,
            8,
            0
        ],
        "positive-100": [
            237,
            252,
            241
        ],
        "positive-200": [
            215,
            247,
            225
        ],
        "positive-300": [
            173,
            238,
            197
        ],
        "positive-400": [
            107,
            227,
            162
        ],
        "positive-500": [
            43,
            209,
            125
        ],
        "positive-600": [
            18,
            184,
            103
        ],
        "positive-700": [
            11,
            164,
            93
        ],
        "positive-800": [
            7,
            147,
            85
        ],
        "positive-900": [
            5,
            131,
            78
        ],
        "positive-1000": [
            3,
            110,
            69
        ],
        "positive-1100": [
            2,
            93,
            60
        ],
        "positive-1200": [
            1,
            76,
            52
        ],
        "positive-1300": [
            0,
            61,
            44
        ],
        "positive-1400": [
            0,
            46,
            34
        ],
        "positive-1500": [
            0,
            33,
            25
        ],
        "positive-1600": [
            0,
            15,
            12
        ],
        "gray-25": [
            255,
            255,
            255
        ],
        "gray-50": [
            248,
            248,
            248
        ],
        "gray-75": [
            243,
            243,
            243
        ],
        "gray-100": [
            233,
            233,
            233
        ],
        "gray-200": [
            225,
            225,
            225
        ],
        "gray-300": [
            218,
            218,
            218
        ],
        "gray-400": [
            198,
            198,
            198
        ],
        "gray-500": [
            143,
            143,
            143
        ],
        "gray-600": [
            113,
            113,
            113
        ],
        "gray-700": [
            80,
            80,
            80
        ],
        "gray-800": [
            41,
            41,
            41
        ],
        "gray-900": [
            19,
            19,
            19
        ],
        "gray-1000": [
            0,
            0,
            0
        ],
        "blue-100": [
            245,
            249,
            255
        ],
        "blue-200": [
            229,
            240,
            254
        ],
        "blue-300": [
            203,
            226,
            254
        ],
        "blue-400": [
            172,
            207,
            253
        ],
        "blue-500": [
            142,
            185,
            252
        ],
        "blue-600": [
            114,
            158,
            253
        ],
        "blue-700": [
            93,
            137,
            255
        ],
        "blue-800": [
            75,
            117,
            255
        ],
        "blue-900": [
            59,
            99,
            251
        ],
        "blue-1000": [
            39,
            77,
            234
        ],
        "blue-1100": [
            29,
            62,
            207
        ],
        "blue-1200": [
            21,
            50,
            173
        ],
        "blue-1300": [
            16,
            40,
            140
        ],
        "blue-1400": [
            12,
            31,
            105
        ],
        "blue-1500": [
            14,
            24,
            67
        ],
        "blue-1600": [
            7,
            11,
            30
        ],
        "red-100": [
            255,
            246,
            245
        ],
        "red-200": [
            255,
            235,
            232
        ],
        "red-300": [
            255,
            214,
            209
        ],
        "red-400": [
            255,
            188,
            180
        ],
        "red-500": [
            255,
            157,
            145
        ],
        "red-600": [
            255,
            118,
            101
        ],
        "red-700": [
            255,
            81,
            61
        ],
        "red-800": [
            240,
            56,
            35
        ],
        "red-900": [
            215,
            50,
            32
        ],
        "red-1000": [
            183,
            40,
            24
        ],
        "red-1100": [
            156,
            33,
            19
        ],
        "red-1200": [
            129,
            27,
            14
        ],
        "red-1300": [
            104,
            21,
            10
        ],
        "red-1400": [
            80,
            16,
            6
        ],
        "red-1500": [
            59,
            11,
            4
        ],
        "red-1600": [
            29,
            5,
            2
        ],
        "orange-100": [
            255,
            246,
            231
        ],
        "orange-200": [
            255,
            236,
            207
        ],
        "orange-300": [
            255,
            218,
            158
        ],
        "orange-400": [
            255,
            193,
            94
        ],
        "orange-500": [
            255,
            162,
            19
        ],
        "orange-600": [
            252,
            125,
            0
        ],
        "orange-700": [
            232,
            106,
            0
        ],
        "orange-800": [
            212,
            91,
            0
        ],
        "orange-900": [
            194,
            78,
            0
        ],
        "orange-1000": [
            167,
            62,
            0
        ],
        "orange-1100": [
            144,
            51,
            0
        ],
        "orange-1200": [
            118,
            41,
            0
        ],
        "orange-1300": [
            95,
            32,
            0
        ],
        "orange-1400": [
            73,
            24,
            0
        ],
        "orange-1500": [
            52,
            18,
            0
        ],
        "orange-1600": [
            25,
            8,
            0
        ],
        "yellow-100": [
            255,
            248,
            204
        ],
        "yellow-200": [
            255,
            241,
            151
        ],
        "yellow-300": [
            255,
            222,
            44
        ],
        "yellow-400": [
            245,
            199,
            0
        ],
        "yellow-500": [
            230,
            175,
            0
        ],
        "yellow-600": [
            210,
            149,
            0
        ],
        "yellow-700": [
            193,
            131,
            0
        ],
        "yellow-800": [
            175,
            116,
            0
        ],
        "yellow-900": [
            158,
            102,
            0
        ],
        "yellow-1000": [
            134,
            85,
            0
        ],
        "yellow-1100": [
            114,
            72,
            0
        ],
        "yellow-1200": [
            93,
            59,
            0
        ],
        "yellow-1300": [
            75,
            47,
            0
        ],
        "yellow-1400": [
            56,
            35,
            0
        ],
        "yellow-1500": [
            40,
            25,
            0
        ],
        "yellow-1600": [
            18,
            11,
            0
        ],
        "chartreuse-100": [
            246,
            251,
            222
        ],
        "chartreuse-200": [
            234,
            246,
            173
        ],
        "chartreuse-300": [
            208,
            236,
            70
        ],
        "chartreuse-400": [
            182,
            219,
            0
        ],
        "chartreuse-500": [
            163,
            196,
            0
        ],
        "chartreuse-600": [
            143,
            172,
            0
        ],
        "chartreuse-700": [
            128,
            153,
            0
        ],
        "chartreuse-800": [
            114,
            137,
            0
        ],
        "chartreuse-900": [
            102,
            122,
            0
        ],
        "chartreuse-1000": [
            86,
            103,
            0
        ],
        "chartreuse-1100": [
            73,
            87,
            0
        ],
        "chartreuse-1200": [
            60,
            71,
            0
        ],
        "chartreuse-1300": [
            47,
            57,
            0
        ],
        "chartreuse-1400": [
            35,
            43,
            0
        ],
        "chartreuse-1500": [
            25,
            30,
            0
        ],
        "chartreuse-1600": [
            11,
            14,
            0
        ],
        "celery-100": [
            235,
            255,
            220
        ],
        "celery-200": [
            197,
            255,
            156
        ],
        "celery-300": [
            157,
            247,
            92
        ],
        "celery-400": [
            129,
            228,
            58
        ],
        "celery-500": [
            110,
            206,
            42
        ],
        "celery-600": [
            93,
            180,
            31
        ],
        "celery-700": [
            82,
            161,
            25
        ],
        "celery-800": [
            72,
            144,
            20
        ],
        "celery-900": [
            64,
            129,
            17
        ],
        "celery-1000": [
            52,
            109,
            12
        ],
        "celery-1100": [
            44,
            92,
            9
        ],
        "celery-1200": [
            35,
            75,
            6
        ],
        "celery-1300": [
            27,
            60,
            3
        ],
        "celery-1400": [
            19,
            46,
            0
        ],
        "celery-1500": [
            12,
            33,
            0
        ],
        "celery-1600": [
            4,
            15,
            0
        ],
        "green-100": [
            237,
            252,
            241
        ],
        "green-200": [
            215,
            247,
            225
        ],
        "green-300": [
            173,
            238,
            197
        ],
        "green-400": [
            107,
            227,
            162
        ],
        "green-500": [
            43,
            209,
            125
        ],
        "green-600": [
            18,
            184,
            103
        ],
        "green-700": [
            11,
            164,
            93
        ],
        "green-800": [
            7,
            147,
            85
        ],
        "green-900": [
            5,
            131,
            78
        ],
        "green-1000": [
            3,
            110,
            69
        ],
        "green-1100": [
            2,
            93,
            60
        ],
        "green-1200": [
            1,
            76,
            52
        ],
        "green-1300": [
            0,
            61,
            44
        ],
        "green-1400": [
            0,
            46,
            34
        ],
        "green-1500": [
            0,
            33,
            25
        ],
        "green-1600": [
            0,
            15,
            12
        ],
        "seafoam-100": [
            235,
            251,
            246
        ],
        "seafoam-200": [
            211,
            246,
            234
        ],
        "seafoam-300": [
            169,
            237,
            216
        ],
        "seafoam-400": [
            92,
            225,
            194
        ],
        "seafoam-500": [
            16,
            207,
            169
        ],
        "seafoam-600": [
            13,
            181,
            149
        ],
        "seafoam-700": [
            11,
            162,
            134
        ],
        "seafoam-800": [
            9,
            144,
            120
        ],
        "seafoam-900": [
            7,
            129,
            109
        ],
        "seafoam-1000": [
            5,
            108,
            92
        ],
        "seafoam-1100": [
            3,
            92,
            80
        ],
        "seafoam-1200": [
            1,
            75,
            67
        ],
        "seafoam-1300": [
            0,
            60,
            54
        ],
        "seafoam-1400": [
            0,
            46,
            40
        ],
        "seafoam-1500": [
            0,
            33,
            29
        ],
        "seafoam-1600": [
            0,
            15,
            14
        ],
        "cyan-100": [
            238,
            250,
            254
        ],
        "cyan-200": [
            217,
            244,
            253
        ],
        "cyan-300": [
            183,
            231,
            252
        ],
        "cyan-400": [
            138,
            213,
            255
        ],
        "cyan-500": [
            92,
            192,
            255
        ],
        "cyan-600": [
            48,
            167,
            254
        ],
        "cyan-700": [
            29,
            149,
            231
        ],
        "cyan-800": [
            18,
            134,
            205
        ],
        "cyan-900": [
            11,
            120,
            179
        ],
        "cyan-1000": [
            4,
            102,
            145
        ],
        "cyan-1100": [
            0,
            87,
            121
        ],
        "cyan-1200": [
            0,
            71,
            98
        ],
        "cyan-1300": [
            0,
            57,
            78
        ],
        "cyan-1400": [
            0,
            43,
            59
        ],
        "cyan-1500": [
            0,
            31,
            43
        ],
        "cyan-1600": [
            0,
            14,
            20
        ],
        "indigo-100": [
            247,
            248,
            255
        ],
        "indigo-200": [
            235,
            238,
            255
        ],
        "indigo-300": [
            216,
            222,
            255
        ],
        "indigo-400": [
            192,
            201,
            255
        ],
        "indigo-500": [
            167,
            178,
            255
        ],
        "indigo-600": [
            145,
            151,
            254
        ],
        "indigo-700": [
            132,
            128,
            254
        ],
        "indigo-800": [
            122,
            106,
            253
        ],
        "indigo-900": [
            113,
            85,
            250
        ],
        "indigo-1000": [
            99,
            56,
            238
        ],
        "indigo-1100": [
            84,
            36,
            219
        ],
        "indigo-1200": [
            69,
            19,
            191
        ],
        "indigo-1300": [
            55,
            6,
            160
        ],
        "indigo-1400": [
            42,
            0,
            129
        ],
        "indigo-1500": [
            31,
            0,
            98
        ],
        "indigo-1600": [
            17,
            0,
            54
        ],
        "purple-100": [
            251,
            247,
            254
        ],
        "purple-200": [
            244,
            235,
            252
        ],
        "purple-300": [
            235,
            218,
            249
        ],
        "purple-400": [
            221,
            193,
            246
        ],
        "purple-500": [
            208,
            167,
            243
        ],
        "purple-600": [
            191,
            138,
            238
        ],
        "purple-700": [
            178,
            114,
            235
        ],
        "purple-800": [
            166,
            92,
            231
        ],
        "purple-900": [
            154,
            71,
            226
        ],
        "purple-1000": [
            134,
            40,
            217
        ],
        "purple-1100": [
            115,
            13,
            204
        ],
        "purple-1200": [
            93,
            0,
            177
        ],
        "purple-1300": [
            75,
            0,
            144
        ],
        "purple-1400": [
            59,
            0,
            111
        ],
        "purple-1500": [
            44,
            0,
            84
        ],
        "purple-1600": [
            23,
            0,
            45
        ],
        "fuchsia-100": [
            254,
            246,
            255
        ],
        "fuchsia-200": [
            253,
            233,
            255
        ],
        "fuchsia-300": [
            250,
            211,
            255
        ],
        "fuchsia-400": [
            247,
            181,
            255
        ],
        "fuchsia-500": [
            243,
            147,
            255
        ],
        "fuchsia-600": [
            236,
            105,
            255
        ],
        "fuchsia-700": [
            223,
            77,
            245
        ],
        "fuchsia-800": [
            200,
            68,
            220
        ],
        "fuchsia-900": [
            181,
            57,
            200
        ],
        "fuchsia-1000": [
            156,
            40,
            175
        ],
        "fuchsia-1100": [
            135,
            27,
            154
        ],
        "fuchsia-1200": [
            113,
            15,
            131
        ],
        "fuchsia-1300": [
            92,
            4,
            109
        ],
        "fuchsia-1400": [
            72,
            0,
            88
        ],
        "fuchsia-1500": [
            54,
            0,
            66
        ],
        "fuchsia-1600": [
            29,
            0,
            35
        ],
        "magenta-100": [
            255,
            245,
            248
        ],
        "magenta-200": [
            255,
            232,
            240
        ],
        "magenta-300": [
            255,
            213,
            227
        ],
        "magenta-400": [
            255,
            185,
            208
        ],
        "magenta-500": [
            255,
            152,
            187
        ],
        "magenta-600": [
            255,
            112,
            159
        ],
        "magenta-700": [
            255,
            72,
            133
        ],
        "magenta-800": [
            240,
            45,
            110
        ],
        "magenta-900": [
            217,
            35,
            97
        ],
        "magenta-1000": [
            186,
            22,
            80
        ],
        "magenta-1100": [
            163,
            5,
            62
        ],
        "magenta-1200": [
            136,
            0,
            51
        ],
        "magenta-1300": [
            111,
            0,
            40
        ],
        "magenta-1400": [
            86,
            0,
            30
        ],
        "magenta-1500": [
            64,
            0,
            22
        ],
        "magenta-1600": [
            35,
            0,
            12
        ],
        "pink-100": [
            255,
            246,
            252
        ],
        "pink-200": [
            255,
            232,
            247
        ],
        "pink-300": [
            255,
            211,
            240
        ],
        "pink-400": [
            255,
            181,
            230
        ],
        "pink-500": [
            255,
            148,
            219
        ],
        "pink-600": [
            255,
            103,
            204
        ],
        "pink-700": [
            242,
            76,
            184
        ],
        "pink-800": [
            228,
            52,
            163
        ],
        "pink-900": [
            206,
            42,
            146
        ],
        "pink-1000": [
            176,
            31,
            123
        ],
        "pink-1100": [
            152,
            22,
            104
        ],
        "pink-1200": [
            128,
            12,
            85
        ],
        "pink-1300": [
            105,
            3,
            68
        ],
        "pink-1400": [
            83,
            0,
            53
        ],
        "pink-1500": [
            62,
            0,
            39
        ],
        "pink-1600": [
            33,
            0,
            21
        ],
        "turquoise-100": [
            238,
            251,
            251
        ],
        "turquoise-200": [
            209,
            245,
            245
        ],
        "turquoise-300": [
            169,
            236,
            237
        ],
        "turquoise-400": [
            111,
            221,
            228
        ],
        "turquoise-500": [
            39,
            202,
            216
        ],
        "turquoise-600": [
            15,
            177,
            192
        ],
        "turquoise-700": [
            12,
            158,
            171
        ],
        "turquoise-800": [
            10,
            141,
            153
        ],
        "turquoise-900": [
            8,
            126,
            137
        ],
        "turquoise-1000": [
            5,
            107,
            116
        ],
        "turquoise-1100": [
            3,
            90,
            98
        ],
        "turquoise-1200": [
            1,
            74,
            81
        ],
        "turquoise-1300": [
            0,
            59,
            65
        ],
        "turquoise-1400": [
            0,
            44,
            49
        ],
        "turquoise-1500": [
            0,
            32,
            35
        ],
        "turquoise-1600": [
            0,
            15,
            17
        ],
        "brown-100": [
            252,
            247,
            242
        ],
        "brown-200": [
            247,
            238,
            225
        ],
        "brown-300": [
            239,
            221,
            195
        ],
        "brown-400": [
            229,
            200,
            157
        ],
        "brown-500": [
            214,
            177,
            123
        ],
        "brown-600": [
            190,
            155,
            104
        ],
        "brown-700": [
            171,
            138,
            90
        ],
        "brown-800": [
            154,
            123,
            77
        ],
        "brown-900": [
            139,
            109,
            66
        ],
        "brown-1000": [
            119,
            91,
            50
        ],
        "brown-1100": [
            103,
            76,
            35
        ],
        "brown-1200": [
            88,
            61,
            21
        ],
        "brown-1300": [
            70,
            49,
            17
        ],
        "brown-1400": [
            52,
            37,
            13
        ],
        "brown-1500": [
            38,
            26,
            9
        ],
        "brown-1600": [
            16,
            12,
            4
        ],
        "silver-100": [
            247,
            247,
            247
        ],
        "silver-200": [
            239,
            239,
            239
        ],
        "silver-300": [
            223,
            223,
            223
        ],
        "silver-400": [
            204,
            204,
            204
        ],
        "silver-500": [
            183,
            183,
            183
        ],
        "silver-600": [
            160,
            160,
            160
        ],
        "silver-700": [
            143,
            143,
            143
        ],
        "silver-800": [
            128,
            128,
            128
        ],
        "silver-900": [
            114,
            114,
            114
        ],
        "silver-1000": [
            96,
            96,
            96
        ],
        "silver-1100": [
            81,
            81,
            81
        ],
        "silver-1200": [
            66,
            66,
            66
        ],
        "silver-1300": [
            52,
            52,
            52
        ],
        "silver-1400": [
            39,
            39,
            39
        ],
        "silver-1500": [
            28,
            28,
            28
        ],
        "silver-1600": [
            12,
            12,
            12
        ],
        "cinnamon-100": [
            253,
            247,
            243
        ],
        "cinnamon-200": [
            249,
            236,
            229
        ],
        "cinnamon-300": [
            244,
            218,
            203
        ],
        "cinnamon-400": [
            237,
            196,
            172
        ],
        "cinnamon-500": [
            229,
            170,
            136
        ],
        "cinnamon-600": [
            212,
            145,
            108
        ],
        "cinnamon-700": [
            198,
            126,
            88
        ],
        "cinnamon-800": [
            184,
            109,
            70
        ],
        "cinnamon-900": [
            170,
            94,
            56
        ],
        "cinnamon-1000": [
            147,
            77,
            43
        ],
        "cinnamon-1100": [
            128,
            62,
            32
        ],
        "cinnamon-1200": [
            110,
            48,
            21
        ],
        "cinnamon-1300": [
            92,
            35,
            11
        ],
        "cinnamon-1400": [
            72,
            25,
            6
        ],
        "cinnamon-1500": [
            52,
            18,
            4
        ],
        "cinnamon-1600": [
            24,
            8,
            2
        ]
    },
    dark: {
        black: [
            0,
            0,
            0
        ],
        white: [
            255,
            255,
            255
        ],
        base: [
            17,
            17,
            17
        ],
        "layer-1": [
            27,
            27,
            27
        ],
        pasteboard: [
            44,
            44,
            44
        ],
        elevated: [
            17,
            17,
            17
        ],
        neutral: [
            219,
            219,
            219
        ],
        disabled: [
            68,
            68,
            68
        ],
        accent: [
            86,
            129,
            255
        ],
        "neutral-subdued": [
            175,
            175,
            175
        ],
        negative: [
            252,
            67,
            46
        ],
        heading: [
            242,
            242,
            242
        ],
        title: [
            242,
            242,
            242
        ],
        body: [
            219,
            219,
            219
        ],
        detail: [
            138,
            138,
            138
        ],
        code: [
            219,
            219,
            219
        ],
        "accent-100": [
            14,
            23,
            63
        ],
        "accent-200": [
            15,
            28,
            82
        ],
        "accent-300": [
            12,
            33,
            117
        ],
        "accent-400": [
            18,
            45,
            154
        ],
        "accent-500": [
            26,
            58,
            195
        ],
        "accent-600": [
            37,
            73,
            229
        ],
        "accent-700": [
            52,
            91,
            248
        ],
        "accent-800": [
            64,
            105,
            253
        ],
        "accent-900": [
            86,
            129,
            255
        ],
        "accent-1000": [
            105,
            149,
            254
        ],
        "accent-1100": [
            124,
            169,
            252
        ],
        "accent-1200": [
            152,
            192,
            252
        ],
        "accent-1300": [
            181,
            213,
            253
        ],
        "accent-1400": [
            213,
            231,
            254
        ],
        "accent-1500": [
            238,
            245,
            255
        ],
        "accent-1600": [
            255,
            255,
            255
        ],
        "informative-100": [
            14,
            23,
            63
        ],
        "informative-200": [
            15,
            28,
            82
        ],
        "informative-300": [
            12,
            33,
            117
        ],
        "informative-400": [
            18,
            45,
            154
        ],
        "informative-500": [
            26,
            58,
            195
        ],
        "informative-600": [
            37,
            73,
            229
        ],
        "informative-700": [
            52,
            91,
            248
        ],
        "informative-800": [
            64,
            105,
            253
        ],
        "informative-900": [
            86,
            129,
            255
        ],
        "informative-1000": [
            105,
            149,
            254
        ],
        "informative-1100": [
            124,
            169,
            252
        ],
        "informative-1200": [
            152,
            192,
            252
        ],
        "informative-1300": [
            181,
            213,
            253
        ],
        "informative-1400": [
            213,
            231,
            254
        ],
        "informative-1500": [
            238,
            245,
            255
        ],
        "informative-1600": [
            255,
            255,
            255
        ],
        "negative-100": [
            54,
            10,
            3
        ],
        "negative-200": [
            68,
            13,
            5
        ],
        "negative-300": [
            87,
            17,
            7
        ],
        "negative-400": [
            115,
            24,
            11
        ],
        "negative-500": [
            147,
            31,
            17
        ],
        "negative-600": [
            177,
            38,
            23
        ],
        "negative-700": [
            205,
            46,
            29
        ],
        "negative-800": [
            223,
            52,
            34
        ],
        "negative-900": [
            252,
            67,
            46
        ],
        "negative-1000": [
            255,
            103,
            86
        ],
        "negative-1100": [
            255,
            134,
            120
        ],
        "negative-1200": [
            255,
            167,
            157
        ],
        "negative-1300": [
            255,
            196,
            189
        ],
        "negative-1400": [
            255,
            222,
            219
        ],
        "negative-1500": [
            255,
            242,
            240
        ],
        "negative-1600": [
            255,
            255,
            255
        ],
        "notice-100": [
            49,
            16,
            0
        ],
        "notice-200": [
            61,
            21,
            0
        ],
        "notice-300": [
            80,
            27,
            0
        ],
        "notice-400": [
            106,
            36,
            0
        ],
        "notice-500": [
            135,
            47,
            0
        ],
        "notice-600": [
            162,
            59,
            0
        ],
        "notice-700": [
            185,
            73,
            0
        ],
        "notice-800": [
            199,
            82,
            0
        ],
        "notice-900": [
            224,
            100,
            0
        ],
        "notice-1000": [
            243,
            117,
            0
        ],
        "notice-1100": [
            255,
            137,
            0
        ],
        "notice-1200": [
            255,
            173,
            45
        ],
        "notice-1300": [
            255,
            201,
            116
        ],
        "notice-1400": [
            255,
            225,
            178
        ],
        "notice-1500": [
            255,
            243,
            225
        ],
        "notice-1600": [
            255,
            255,
            255
        ],
        "positive-100": [
            0,
            30,
            23
        ],
        "positive-200": [
            0,
            38,
            29
        ],
        "positive-300": [
            0,
            51,
            38
        ],
        "positive-400": [
            0,
            68,
            48
        ],
        "positive-500": [
            2,
            87,
            58
        ],
        "positive-600": [
            3,
            106,
            67
        ],
        "positive-700": [
            4,
            124,
            75
        ],
        "positive-800": [
            6,
            136,
            80
        ],
        "positive-900": [
            9,
            157,
            89
        ],
        "positive-1000": [
            14,
            175,
            98
        ],
        "positive-1100": [
            24,
            193,
            110
        ],
        "positive-1200": [
            57,
            215,
            134
        ],
        "positive-1300": [
            126,
            231,
            172
        ],
        "positive-1400": [
            189,
            241,
            208
        ],
        "positive-1500": [
            229,
            250,
            236
        ],
        "positive-1600": [
            255,
            255,
            255
        ],
        "gray-25": [
            17,
            17,
            17
        ],
        "gray-50": [
            27,
            27,
            27
        ],
        "gray-75": [
            34,
            34,
            34
        ],
        "gray-100": [
            44,
            44,
            44
        ],
        "gray-200": [
            50,
            50,
            50
        ],
        "gray-300": [
            57,
            57,
            57
        ],
        "gray-400": [
            68,
            68,
            68
        ],
        "gray-500": [
            109,
            109,
            109
        ],
        "gray-600": [
            138,
            138,
            138
        ],
        "gray-700": [
            175,
            175,
            175
        ],
        "gray-800": [
            219,
            219,
            219
        ],
        "gray-900": [
            242,
            242,
            242
        ],
        "gray-1000": [
            255,
            255,
            255
        ],
        "blue-100": [
            14,
            23,
            63
        ],
        "blue-200": [
            15,
            28,
            82
        ],
        "blue-300": [
            12,
            33,
            117
        ],
        "blue-400": [
            18,
            45,
            154
        ],
        "blue-500": [
            26,
            58,
            195
        ],
        "blue-600": [
            37,
            73,
            229
        ],
        "blue-700": [
            52,
            91,
            248
        ],
        "blue-800": [
            64,
            105,
            253
        ],
        "blue-900": [
            86,
            129,
            255
        ],
        "blue-1000": [
            105,
            149,
            254
        ],
        "blue-1100": [
            124,
            169,
            252
        ],
        "blue-1200": [
            152,
            192,
            252
        ],
        "blue-1300": [
            181,
            213,
            253
        ],
        "blue-1400": [
            213,
            231,
            254
        ],
        "blue-1500": [
            238,
            245,
            255
        ],
        "blue-1600": [
            255,
            255,
            255
        ],
        "red-100": [
            54,
            10,
            3
        ],
        "red-200": [
            68,
            13,
            5
        ],
        "red-300": [
            87,
            17,
            7
        ],
        "red-400": [
            115,
            24,
            11
        ],
        "red-500": [
            147,
            31,
            17
        ],
        "red-600": [
            177,
            38,
            23
        ],
        "red-700": [
            205,
            46,
            29
        ],
        "red-800": [
            223,
            52,
            34
        ],
        "red-900": [
            252,
            67,
            46
        ],
        "red-1000": [
            255,
            103,
            86
        ],
        "red-1100": [
            255,
            134,
            120
        ],
        "red-1200": [
            255,
            167,
            157
        ],
        "red-1300": [
            255,
            196,
            189
        ],
        "red-1400": [
            255,
            222,
            219
        ],
        "red-1500": [
            255,
            242,
            240
        ],
        "red-1600": [
            255,
            255,
            255
        ],
        "orange-100": [
            49,
            16,
            0
        ],
        "orange-200": [
            61,
            21,
            0
        ],
        "orange-300": [
            80,
            27,
            0
        ],
        "orange-400": [
            106,
            36,
            0
        ],
        "orange-500": [
            135,
            47,
            0
        ],
        "orange-600": [
            162,
            59,
            0
        ],
        "orange-700": [
            185,
            73,
            0
        ],
        "orange-800": [
            199,
            82,
            0
        ],
        "orange-900": [
            224,
            100,
            0
        ],
        "orange-1000": [
            243,
            117,
            0
        ],
        "orange-1100": [
            255,
            137,
            0
        ],
        "orange-1200": [
            255,
            173,
            45
        ],
        "orange-1300": [
            255,
            201,
            116
        ],
        "orange-1400": [
            255,
            225,
            178
        ],
        "orange-1500": [
            255,
            243,
            225
        ],
        "orange-1600": [
            255,
            255,
            255
        ],
        "yellow-100": [
            37,
            23,
            0
        ],
        "yellow-200": [
            47,
            29,
            0
        ],
        "yellow-300": [
            61,
            39,
            0
        ],
        "yellow-400": [
            83,
            52,
            0
        ],
        "yellow-500": [
            107,
            67,
            0
        ],
        "yellow-600": [
            130,
            82,
            0
        ],
        "yellow-700": [
            151,
            97,
            0
        ],
        "yellow-800": [
            164,
            106,
            0
        ],
        "yellow-900": [
            186,
            124,
            0
        ],
        "yellow-1000": [
            203,
            141,
            0
        ],
        "yellow-1100": [
            218,
            159,
            0
        ],
        "yellow-1200": [
            235,
            183,
            0
        ],
        "yellow-1300": [
            249,
            206,
            0
        ],
        "yellow-1400": [
            255,
            230,
            86
        ],
        "yellow-1500": [
            255,
            246,
            195
        ],
        "yellow-1600": [
            255,
            255,
            255
        ],
        "chartreuse-100": [
            23,
            28,
            0
        ],
        "chartreuse-200": [
            30,
            36,
            0
        ],
        "chartreuse-300": [
            39,
            47,
            0
        ],
        "chartreuse-400": [
            53,
            63,
            0
        ],
        "chartreuse-500": [
            68,
            82,
            0
        ],
        "chartreuse-600": [
            83,
            100,
            0
        ],
        "chartreuse-700": [
            97,
            116,
            0
        ],
        "chartreuse-800": [
            106,
            127,
            0
        ],
        "chartreuse-900": [
            122,
            147,
            0
        ],
        "chartreuse-1000": [
            136,
            164,
            0
        ],
        "chartreuse-1100": [
            151,
            181,
            0
        ],
        "chartreuse-1200": [
            169,
            203,
            0
        ],
        "chartreuse-1300": [
            187,
            225,
            0
        ],
        "chartreuse-1400": [
            219,
            240,
            117
        ],
        "chartreuse-1500": [
            242,
            249,
            206
        ],
        "chartreuse-1600": [
            255,
            255,
            255
        ],
        "celery-100": [
            11,
            31,
            0
        ],
        "celery-200": [
            15,
            38,
            0
        ],
        "celery-300": [
            21,
            51,
            1
        ],
        "celery-400": [
            31,
            67,
            4
        ],
        "celery-500": [
            41,
            86,
            8
        ],
        "celery-600": [
            50,
            105,
            11
        ],
        "celery-700": [
            60,
            122,
            15
        ],
        "celery-800": [
            66,
            134,
            18
        ],
        "celery-900": [
            78,
            154,
            23
        ],
        "celery-1000": [
            88,
            172,
            28
        ],
        "celery-1100": [
            100,
            190,
            35
        ],
        "celery-1200": [
            116,
            213,
            46
        ],
        "celery-1300": [
            136,
            234,
            65
        ],
        "celery-1400": [
            170,
            251,
            112
        ],
        "celery-1500": [
            222,
            255,
            198
        ],
        "celery-1600": [
            255,
            255,
            255
        ],
        "green-100": [
            0,
            30,
            23
        ],
        "green-200": [
            0,
            38,
            29
        ],
        "green-300": [
            0,
            51,
            38
        ],
        "green-400": [
            0,
            68,
            48
        ],
        "green-500": [
            2,
            87,
            58
        ],
        "green-600": [
            3,
            106,
            67
        ],
        "green-700": [
            4,
            124,
            75
        ],
        "green-800": [
            6,
            136,
            80
        ],
        "green-900": [
            9,
            157,
            89
        ],
        "green-1000": [
            14,
            175,
            98
        ],
        "green-1100": [
            24,
            193,
            110
        ],
        "green-1200": [
            57,
            215,
            134
        ],
        "green-1300": [
            126,
            231,
            172
        ],
        "green-1400": [
            189,
            241,
            208
        ],
        "green-1500": [
            229,
            250,
            236
        ],
        "green-1600": [
            255,
            255,
            255
        ],
        "seafoam-100": [
            0,
            30,
            27
        ],
        "seafoam-200": [
            0,
            39,
            35
        ],
        "seafoam-300": [
            0,
            50,
            44
        ],
        "seafoam-400": [
            0,
            67,
            59
        ],
        "seafoam-500": [
            2,
            86,
            75
        ],
        "seafoam-600": [
            4,
            105,
            89
        ],
        "seafoam-700": [
            6,
            122,
            103
        ],
        "seafoam-800": [
            8,
            134,
            112
        ],
        "seafoam-900": [
            10,
            154,
            128
        ],
        "seafoam-1000": [
            12,
            173,
            142
        ],
        "seafoam-1100": [
            14,
            190,
            156
        ],
        "seafoam-1200": [
            29,
            214,
            176
        ],
        "seafoam-1300": [
            122,
            229,
            203
        ],
        "seafoam-1400": [
            186,
            241,
            222
        ],
        "seafoam-1500": [
            229,
            249,
            243
        ],
        "seafoam-1600": [
            255,
            255,
            255
        ],
        "cyan-100": [
            0,
            29,
            39
        ],
        "cyan-200": [
            0,
            36,
            49
        ],
        "cyan-300": [
            0,
            48,
            65
        ],
        "cyan-400": [
            0,
            64,
            88
        ],
        "cyan-500": [
            0,
            82,
            113
        ],
        "cyan-600": [
            3,
            99,
            140
        ],
        "cyan-700": [
            8,
            115,
            168
        ],
        "cyan-800": [
            13,
            125,
            186
        ],
        "cyan-900": [
            24,
            142,
            220
        ],
        "cyan-1000": [
            38,
            159,
            244
        ],
        "cyan-1100": [
            63,
            177,
            255
        ],
        "cyan-1200": [
            107,
            199,
            255
        ],
        "cyan-1300": [
            152,
            219,
            255
        ],
        "cyan-1400": [
            195,
            236,
            252
        ],
        "cyan-1500": [
            230,
            248,
            253
        ],
        "cyan-1600": [
            255,
            255,
            255
        ],
        "indigo-100": [
            30,
            0,
            93
        ],
        "indigo-200": [
            35,
            0,
            110
        ],
        "indigo-300": [
            47,
            0,
            140
        ],
        "indigo-400": [
            62,
            12,
            174
        ],
        "indigo-500": [
            79,
            30,
            209
        ],
        "indigo-600": [
            95,
            52,
            235
        ],
        "indigo-700": [
            109,
            75,
            248
        ],
        "indigo-800": [
            116,
            91,
            252
        ],
        "indigo-900": [
            128,
            119,
            254
        ],
        "indigo-1000": [
            139,
            141,
            254
        ],
        "indigo-1100": [
            153,
            161,
            255
        ],
        "indigo-1200": [
            176,
            186,
            255
        ],
        "indigo-1300": [
            199,
            208,
            255
        ],
        "indigo-1400": [
            223,
            228,
            255
        ],
        "indigo-1500": [
            243,
            244,
            255
        ],
        "indigo-1600": [
            255,
            255,
            255
        ],
        "purple-100": [
            41,
            0,
            79
        ],
        "purple-200": [
            50,
            0,
            96
        ],
        "purple-300": [
            64,
            0,
            122
        ],
        "purple-400": [
            83,
            0,
            159
        ],
        "purple-500": [
            107,
            6,
            195
        ],
        "purple-600": [
            130,
            34,
            215
        ],
        "purple-700": [
            148,
            62,
            224
        ],
        "purple-800": [
            157,
            78,
            228
        ],
        "purple-900": [
            173,
            105,
            233
        ],
        "purple-1000": [
            186,
            127,
            237
        ],
        "purple-1100": [
            197,
            149,
            240
        ],
        "purple-1200": [
            212,
            176,
            244
        ],
        "purple-1300": [
            225,
            201,
            247
        ],
        "purple-1400": [
            238,
            224,
            250
        ],
        "purple-1500": [
            248,
            243,
            253
        ],
        "purple-1600": [
            255,
            255,
            255
        ],
        "fuchsia-100": [
            50,
            0,
            61
        ],
        "fuchsia-200": [
            61,
            0,
            74
        ],
        "fuchsia-300": [
            79,
            0,
            95
        ],
        "fuchsia-400": [
            102,
            9,
            120
        ],
        "fuchsia-500": [
            127,
            23,
            146
        ],
        "fuchsia-600": [
            151,
            38,
            170
        ],
        "fuchsia-700": [
            173,
            51,
            192
        ],
        "fuchsia-800": [
            186,
            60,
            206
        ],
        "fuchsia-900": [
            213,
            73,
            235
        ],
        "fuchsia-1000": [
            232,
            91,
            253
        ],
        "fuchsia-1100": [
            240,
            122,
            255
        ],
        "fuchsia-1200": [
            245,
            159,
            255
        ],
        "fuchsia-1300": [
            248,
            191,
            255
        ],
        "fuchsia-1400": [
            251,
            219,
            255
        ],
        "fuchsia-1500": [
            253,
            241,
            255
        ],
        "fuchsia-1600": [
            255,
            255,
            255
        ],
        "magenta-100": [
            59,
            0,
            22
        ],
        "magenta-200": [
            74,
            0,
            27
        ],
        "magenta-300": [
            93,
            0,
            34
        ],
        "magenta-400": [
            123,
            0,
            45
        ],
        "magenta-500": [
            152,
            7,
            60
        ],
        "magenta-600": [
            181,
            19,
            76
        ],
        "magenta-700": [
            207,
            31,
            92
        ],
        "magenta-800": [
            224,
            38,
            101
        ],
        "magenta-900": [
            255,
            51,
            119
        ],
        "magenta-1000": [
            255,
            96,
            149
        ],
        "magenta-1100": [
            255,
            128,
            171
        ],
        "magenta-1200": [
            255,
            163,
            194
        ],
        "magenta-1300": [
            255,
            193,
            214
        ],
        "magenta-1400": [
            255,
            220,
            232
        ],
        "magenta-1500": [
            255,
            241,
            246
        ],
        "magenta-1600": [
            255,
            255,
            255
        ],
        "pink-100": [
            58,
            0,
            37
        ],
        "pink-200": [
            71,
            0,
            44
        ],
        "pink-300": [
            90,
            0,
            57
        ],
        "pink-400": [
            115,
            7,
            75
        ],
        "pink-500": [
            143,
            18,
            97
        ],
        "pink-600": [
            171,
            29,
            119
        ],
        "pink-700": [
            196,
            39,
            138
        ],
        "pink-800": [
            213,
            45,
            151
        ],
        "pink-900": [
            236,
            67,
            175
        ],
        "pink-1000": [
            251,
            90,
            196
        ],
        "pink-1100": [
            255,
            122,
            210
        ],
        "pink-1200": [
            255,
            159,
            223
        ],
        "pink-1300": [
            255,
            191,
            234
        ],
        "pink-1400": [
            255,
            219,
            243
        ],
        "pink-1500": [
            255,
            241,
            250
        ],
        "pink-1600": [
            255,
            255,
            255
        ],
        "turquoise-100": [
            0,
            30,
            33
        ],
        "turquoise-200": [
            0,
            37,
            41
        ],
        "turquoise-300": [
            0,
            49,
            54
        ],
        "turquoise-400": [
            0,
            66,
            72
        ],
        "turquoise-500": [
            3,
            84,
            92
        ],
        "turquoise-600": [
            5,
            103,
            112
        ],
        "turquoise-700": [
            7,
            120,
            131
        ],
        "turquoise-800": [
            9,
            131,
            142
        ],
        "turquoise-900": [
            11,
            151,
            164
        ],
        "turquoise-1000": [
            13,
            168,
            182
        ],
        "turquoise-1100": [
            16,
            186,
            202
        ],
        "turquoise-1200": [
            64,
            208,
            220
        ],
        "turquoise-1300": [
            128,
            225,
            231
        ],
        "turquoise-1400": [
            183,
            240,
            240
        ],
        "turquoise-1500": [
            228,
            249,
            249
        ],
        "turquoise-1600": [
            255,
            255,
            255
        ],
        "brown-100": [
            35,
            24,
            8
        ],
        "brown-200": [
            44,
            31,
            11
        ],
        "brown-300": [
            58,
            40,
            14
        ],
        "brown-400": [
            78,
            55,
            19
        ],
        "brown-500": [
            98,
            71,
            30
        ],
        "brown-600": [
            115,
            88,
            47
        ],
        "brown-700": [
            132,
            104,
            61
        ],
        "brown-800": [
            143,
            114,
            69
        ],
        "brown-900": [
            163,
            132,
            84
        ],
        "brown-1000": [
            181,
            147,
            98
        ],
        "brown-1100": [
            199,
            163,
            112
        ],
        "brown-1200": [
            222,
            185,
            130
        ],
        "brown-1300": [
            232,
            207,
            169
        ],
        "brown-1400": [
            242,
            227,
            206
        ],
        "brown-1500": [
            250,
            244,
            236
        ],
        "brown-1600": [
            255,
            255,
            255
        ],
        "silver-100": [
            26,
            26,
            26
        ],
        "silver-200": [
            33,
            33,
            33
        ],
        "silver-300": [
            44,
            44,
            44
        ],
        "silver-400": [
            59,
            59,
            59
        ],
        "silver-500": [
            76,
            76,
            76
        ],
        "silver-600": [
            92,
            92,
            92
        ],
        "silver-700": [
            108,
            108,
            108
        ],
        "silver-800": [
            118,
            118,
            118
        ],
        "silver-900": [
            137,
            137,
            137
        ],
        "silver-1000": [
            152,
            152,
            152
        ],
        "silver-1100": [
            169,
            169,
            169
        ],
        "silver-1200": [
            190,
            190,
            190
        ],
        "silver-1300": [
            211,
            211,
            211
        ],
        "silver-1400": [
            229,
            229,
            229
        ],
        "silver-1500": [
            244,
            244,
            244
        ],
        "silver-1600": [
            255,
            255,
            255
        ],
        "cinnamon-100": [
            48,
            17,
            4
        ],
        "cinnamon-200": [
            59,
            21,
            5
        ],
        "cinnamon-300": [
            79,
            28,
            7
        ],
        "cinnamon-400": [
            100,
            41,
            15
        ],
        "cinnamon-500": [
            122,
            57,
            28
        ],
        "cinnamon-600": [
            143,
            74,
            40
        ],
        "cinnamon-700": [
            163,
            88,
            52
        ],
        "cinnamon-800": [
            176,
            98,
            59
        ],
        "cinnamon-900": [
            192,
            119,
            80
        ],
        "cinnamon-1000": [
            206,
            136,
            99
        ],
        "cinnamon-1100": [
            220,
            154,
            118
        ],
        "cinnamon-1200": [
            232,
            179,
            149
        ],
        "cinnamon-1300": [
            239,
            203,
            183
        ],
        "cinnamon-1400": [
            246,
            225,
            214
        ],
        "cinnamon-1500": [
            252,
            244,
            239
        ],
        "cinnamon-1600": [
            255,
            255,
            255
        ]
    }
};
const backgroundColors = [
    'black',
    'white',
    'base',
    'layer-1',
    'layer-2',
    'pasteboard',
    'elevated',
    'accent',
    'accent-subtle',
    'neutral',
    'neutral-subdued',
    'neutral-subtle',
    'negative',
    'negative-subtle',
    'informative',
    'informative-subtle',
    'positive',
    'positive-subtle',
    'notice',
    'notice-subtle',
    'gray',
    'gray-subtle',
    'red',
    'red-subtle',
    'orange',
    'orange-subtle',
    'yellow',
    'yellow-subtle',
    'chartreuse',
    'chartreuse-subtle',
    'celery',
    'celery-subtle',
    'green',
    'green-subtle',
    'seafoam',
    'seafoam-subtle',
    'cyan',
    'cyan-subtle',
    'blue',
    'blue-subtle',
    'indigo',
    'indigo-subtle',
    'purple',
    'purple-subtle',
    'fuchsia',
    'fuchsia-subtle',
    'magenta',
    'magenta-subtle',
    'pink',
    'pink-subtle',
    'turquoise',
    'turquoise-subtle',
    'cinnamon',
    'cinnamon-subtle',
    'brown',
    'brown-subtle',
    'silver',
    'silver-subtle',
    'disabled'
];
const textColors = [
    'black',
    'white',
    'accent',
    'neutral',
    'neutral-subdued',
    'negative',
    'disabled',
    'heading',
    'title',
    'body',
    'detail',
    'code'
];
const semanticColorRanges = {
    'accent-color': [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    'informative-color': [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    'negative-color': [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    'notice-color': [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    'positive-color': [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ]
};
const globalColorRanges = {
    gray: [
        25,
        50,
        75,
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000
    ],
    blue: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    red: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    orange: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    yellow: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    chartreuse: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    celery: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    green: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    seafoam: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    cyan: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    indigo: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    purple: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    fuchsia: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    magenta: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    pink: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    turquoise: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    brown: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    silver: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ],
    cinnamon: [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900,
        1000,
        1100,
        1200,
        1300,
        1400,
        1500,
        1600
    ]
};
const semanticColors = Object.entries(semanticColorRanges).flatMap(([scale, ranges])=>ranges.map((value)=>({
            name: `${scale.replace('-color', '')}-${value}`,
            section: 'Semantic colors',
            type: 'backgroundColor'
        })));
const globalColors = Object.entries(globalColorRanges).flatMap(([scale, ranges])=>ranges.map((value)=>({
            name: `${scale}-${value}`,
            section: 'Global colors',
            type: 'backgroundColor'
        })));
const colorSections = [
    {
        id: 'background',
        name: 'Background colors',
        items: backgroundColors.map((name)=>({
                name,
                section: 'Background colors',
                type: 'backgroundColor'
            }))
    },
    {
        id: 'text',
        name: 'Text colors',
        items: textColors.map((name)=>({
                name,
                section: 'Text colors',
                type: 'color'
            }))
    },
    {
        id: 'semantic',
        name: 'Semantic colors',
        items: semanticColors
    },
    {
        id: 'global',
        name: 'Global colors',
        items: globalColors
    }
];
const skeletonItemStyle = function anonymous(props) {
    let rules = " ";
    rules += ' sd15';
    rules += ' _ta15';
    rules += ' _Ca15';
    rules += ' eb15';
    rules += ' UH5kTnc15';
    rules += ' qH5kTnc15';
    rules += ' Tt15';
    rules += ' Qt15';
    rules += ' St15';
    rules += ' Rt15';
    if (props.isSelected) rules += ' g015';
    else if (props.isFocused) rules += ' gH15';
    else if (props.isHovered) rules += ' gH15';
    else rules += ' gqlRAZb15';
    rules += ' pt15';
    rules += ' uk15';
    rules += ' ucJ9TBTb15';
    rules += ' ud3Euai15';
    rules += ' uea15';
    rules += ' ugb15';
    rules += ' uhd15';
    rules += ' uje15';
    rules += ' u2NhKxcl15';
    rules += ' uic15';
    rules += ' -_6BNtrc-b15';
    rules += ' vFHT6Dd15';
    rules += ' xb15';
    rules += ' _xa15';
    rules += ' _Fd15';
    rules += ' _FnuYUweb15';
    rules += ' oH5kTnc15';
    rules += ' nH5kTnc15';
    rules += ' kH5kTnc15';
    rules += ' jH5kTnc15';
    rules += ' Yd15';
    rules += ' Xb15';
    rules += ' _2b15';
    rules += ' ri15';
    rules += ' Za15';
    rules += ' Fb15';
    return rules;
};
const skeletonSwatchStyle = " ZifsFYc15 FifsFYc15 oR3ltQc15 nR3ltQc15 kR3ltQc15 jR3ltQc15 _kb15 hb15 mb15 lb15 ia9LI815 _jf15 _va15 _yb15";
const listBoxStyle = " Za15 sd15 _ta15 Us7Vxmb15 qs7Vxmb15";
const sectionStyle = " se15 DruOufb15 UerlM8c15 qerlM8c15 Tt15 Qt15 St15 Rt15 GB1JKEb15";
const headerStyle = " uk15 ucJ9TBTb15 ud3Euai15 uea15 ugb15 uhd15 uje15 u2NhKxcl15 uic15 -_6BNtrc-f15 vFHT6Dd15 xe15 _xa15 xX0cczbd15 _xX0cczba15 xfe15 _xfa15 xfX0cczbd15 _xfX0cczba15 _Fd15 _FnuYUweb15 po15 z2mU15 yzZKy15 GR3ltQc15";
function InfoMessage({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " sd15 UR3ltQc15 qR3ltQc15 Tt15 Qt15 St15 Rt15 eb15",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoCircleDefault.default), {
                styles: " ZokSYvd15 FokSYvd15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " uk15 ucJ9TBTb15 ud3Euai15 uea15 ugb15 uhd15 uje15 u2NhKxcl15 uic15 -_6BNtrc-c15 vFHT6Dd15 xb15 _xa15 _Fd15 _FnuYUweb15 pt15",
                children: children
            })
        ]
    });
}
function SkeletonColorItem({ item }) {
    const ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBoxItem), {
        id: item.id,
        value: item,
        textValue: "skeleton",
        className: skeletonItemStyle,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: skeletonSwatchStyle,
                style: {
                    width: '48px',
                    height: '48px',
                    backgroundColor: 'var(--s2-gray-200)'
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " La15 _Yb15 _Nc15 Pc15 _7c15 _Wa15",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                    styles: " uk15 ucJ9TBTb15 ud3Euai15 uea15 ugb15 uhd15 uje15 u2NhKxcl15 uic15 -_6BNtrc-b15 vFHT6Dd15 xb15 _xa15 _Fd15 _FnuYUweb15 pt15",
                    children: "Color Name"
                })
            })
        ]
    });
}
function ColorSearchSkeleton() {
    const mockSections = (0, _react.useMemo)(()=>[
            {
                id: 'background',
                name: 'Background colors',
                items: Array.from({
                    length: 59
                }, (_, i)=>({
                        id: `skeleton-background-${i}`
                    }))
            },
            {
                id: 'text',
                name: 'Text colors',
                items: Array.from({
                    length: 12
                }, (_, i)=>({
                        id: `skeleton-text-${i}`
                    }))
            },
            {
                id: 'semantic',
                name: 'Semantic colors',
                items: Array.from({
                    length: 80
                }, (_, i)=>({
                        id: `skeleton-semantic-${i}`
                    }))
            },
            {
                id: 'global',
                name: 'Global colors',
                items: Array.from({
                    length: 301
                }, (_, i)=>({
                        id: `skeleton-global-${i}`
                    }))
            }
        ], []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " sd15 _ta15 UH5kTnc15 qH5kTnc15",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InfoMessage, {
                children: [
                    "Press a color to copy its name. See ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
                        href: "styling",
                        children: "styling"
                    }),
                    " for more information."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Skeleton), {
                isLoading: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                    "aria-label": "Colors loading",
                    layout: "grid",
                    className: listBoxStyle,
                    items: mockSections,
                    children: (section)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ListBoxSection), {
                            id: section.id,
                            className: sectionStyle,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Header), {
                                    className: headerStyle,
                                    children: section.name
                                }),
                                section.items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonColorItem, {
                                        item: item
                                    }, item.id))
                            ]
                        })
                })
            })
        ]
    });
}

},{"0":"iJFSU","1":"iTm5O","2":"8tjvH","3":"3ufKh","4":"dI9hy","5":"j6S3W","6":"9w30J","7":"9cPFB","8":"5AY9r","9":"10HS1","10":"6NFDa","react/jsx-runtime":"2Is6Z","react-aria-components":[["Header","kpwoY"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxSection","dNdIK"]],"@react-spectrum/s2/icons/InfoCircle":"hByEX","@react-spectrum/s2":[["Link","42COX"],["Skeleton","1mUnF"],["Text","10r6w"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iJFSU":[function() {},{}],"iTm5O":[function() {},{}],"8tjvH":[function() {},{}],"3ufKh":[function() {},{}],"dI9hy":[function() {},{}],"j6S3W":[function() {},{}],"9w30J":[function() {},{}],"9cPFB":[function() {},{}],"5AY9r":[function() {},{}],"10HS1":[function() {},{}],"6NFDa":[function() {},{}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=icons.2f5266f4.js.map
